import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import '@fontsource/oswald';
import '@fontsource/roboto';
import { ShowyedaLogo } from 'app/components/ShowyedaLogo';
import { Outlet } from 'react-router-dom';
import horseBg from './assets/img/bg/coach-reg-new.jpg';
import tryitImg from './assets/img/bg/tryit.png';
//Font-arimo
import '@fontsource/arimo';
import useSeasonApi from 'admin/hooks/useSeasonApi';
import useRegistrationPageImageApi from 'admin/hooks/useRegistrationPageImageApi ';
import { formatImageUrl } from 'app/pages/LoginPage';
import LoaderWrapper from 'app/components/CircularLoader/LoaderWrapper';
import CircularLoader from 'app/components/CircularLoader';

type Props = {};

const CoachTryItLayout = (props: Props) => {
  const { currentSeasonInDropDown, serviceDataList } = useSeasonApi();
  const {
    loading: isImageLoading,
    getRegistrationPageImageByType, imageByType
  } = useRegistrationPageImageApi();
  useEffect(() => {
    currentSeasonInDropDown();
    getRegistrationPageImageByType(8)
  }, []);

  return (
    <>
      {
        isImageLoading ? (
          <LoaderWrapper>
            <CircularLoader />
          </LoaderWrapper >
        ) : (
          <MainWrapper>
            <LeftWrapper className="LeftWrapper" backgroundImage={imageByType?.imageUrl ? formatImageUrl(imageByType?.imageUrl) : horseBg}>
              <LeftSubWrapper className="LeftSubWrapper">
                <ShowyedaLogo />
                <div className="left-header-block">
                  <p>
                    <span className="note-bold-text"></span> This gives the coach
                    temporary yeda membership to coach for a weekend. if the coach
                    decides within 30 days to upgrade to a regular membership this $20
                    will be applied to a regular yeda coach membership.
                  </p>
                </div>
                <BottomImgWrapper className="BottomImgWrapper">
                  <TryImg src={tryitImg} />
                  {/* <ImgTag src={horseBg} /> */}
                </BottomImgWrapper>
              </LeftSubWrapper>
            </LeftWrapper>
            <RightWrapper className="RightWrapper">
              <BorderWrapper className="BorderWrapper">
                <TopWrapper className="TopWrapper">
                  <ToplabelWrapper>
                    <h3 className="toplabel-header">
                      YEDA Coach Registration Form TRY IT
                      <span
                        style={{
                          fontFamily: 'Arimo',
                        }}
                        className=""
                      >
                        {serviceDataList?.liveSeason?.name}
                      </span>
                    </h3>
                  </ToplabelWrapper>
                </TopWrapper>
                <Outlet />
              </BorderWrapper>
            </RightWrapper>
          </MainWrapper>
        )}
    </>
  );
};
const MainWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  @media (min-width: 100px) and (max-width: 319px) {
    .TopWrapper {
      .toplabel-header {
        font-size: 12px;
      }
    }
    .LeftWrapper {
      display: none;
    }
    .RightWrapper {
      width: 100%;
      padding: 30px 15px 20px;
      .inner-BorderWrapper {
        padding: 20px 20px 0px 20px;
      }
    }
  }
  @media (min-width: 320px) and (max-width: 575px) {
    .TopWrapper {
      .toplabel-header {
        font-size: 13px;
      }
    }
    .LeftWrapper {
      display: none;
    }
    .RightWrapper {
      width: 100%;
      padding: 30px 15px 20px;
      .inner-BorderWrapper {
        padding: 20px 20px 0px 20px;
      }
    }
  }
  @media (min-width: 576px) and (max-width: 767px) {
    .LeftWrapper {
      display: none;
    }
    .RightWrapper {
      width: 100%;
      padding: 30px 15px 20px;
      .inner-BorderWrapper {
        padding: 20px 20px 0px 20px;
      }
    }
    .TopWrapper {
      top: -10px;
      .toplabel-header {
        font-size: 14px;
      }
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .LeftWrapper {
      .left-header-block {
        p {
          font-size: 12px;
        }
      }
    }
    .RightWrapper {
      padding: 30px 15px 20px;
      .inner-BorderWrapper {
        padding: 20px 20px 0px 20px;
      }
    }
    .TopWrapper {
      .toplabel-header {
        font-size: 18px;
      }
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .LeftWrapper {
      .left-header-block {
        p {
          font-size: 14px;
        }
      }
    }
    .RightWrapper {
      padding: 30px 15px 20px;
      .inner-BorderWrapper {
        padding: 20px 20px 0px 20px;
      }
    }
    .TopWrapper {
      .toplabel-header {
        font-size: 19px;
      }
    }
  }
  @media (min-width: 1200px) and (max-width: 1365px) {
    .LeftWrapper {
      .left-header-block {
        p {
          font-size: 15px;
        }
      }
    }
    .TopWrapper {
      .toplabel-header {
        font-size: 20px;
      }
    }
  }
  @media (min-width: 1366px) and (max-width: 1448px) {
    .LeftWrapper {
      .left-header-block {
        p {
          font-size: 16px;
        }
      }
    }
    .TopWrapper {
      .toplabel-header {
        font-size: 21px;
      }
    }
  }
  @media (min-width: 1449px) and (max-width: 1719px) {
    .LeftWrapper {
      .left-header-block {
        p {
          font-size: 17px;
        }
      }
    }
    .TopWrapper {
      .toplabel-header {
        font-size: 23px;
      }
    }
  }
  @media (min-width: 1720px) and (max-width: 4000px) {
    .LeftWrapper {
      .left-header-block {
        p {
          font-size: 19px;
        }
      }
    }
    .TopWrapper {
      .toplabel-header {
        font-size: 25px;
      }
    }
  }
`;
const LeftWrapper = styled.div<{ backgroundImage?: string }>`
  width: 36%;
  /* background: #1b1b1b; */
  height: 100%;
  position: relative;
  background: url(${props => props.backgroundImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  .left-header-block {
    background: black;
    opacity: 0.7;
    padding: 0 20px;
    position: absolute;
    top: 35%;
  }
`;
const LeftSubWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: space-between; */
  padding: 10px 20px;
  /* position: relative; */

  p {
    color: #d1d1d1;
    font-size: 18px;
    font-family: 'Oswald';

    .note-bold-text {
      font-size: 18px;
      text-transform: uppercase;
      color: #ffffff;
    }
  }
  span {
    color: #ffffff;
    font-family: 'Oswald';
    font-size: 14px;
  }

  @media (min-width: 1200px) and (max-width: 1365px) {
    padding: 40px 28px;
  }
  @media (min-width: 1366px) and (max-width: 1448px) {
    padding: 60px 35px;
  }
`;
const BottomImgWrapper = styled.div`
  filter: drop-shadow(2px 4px 6px black);
  position: absolute;
  top: 27%;
  right: 2%;
  /* display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 15px 0; */
`;
const ImgTag = styled.img`
  /* width: 100%; */
  max-width: 100% !important;
  /* min-height: 400px; */
  max-height: calc(100vh - 253px);
  object-fit: contain;
  object-position: center;
  position: relative;
  padding: 0 15px;
  @media (min-width: 576px) and (max-width: 767px) {
    max-height: calc(100vh - 305px);
  }
  @media (min-width: 768px) and (max-width: 991px) {
    max-height: calc(100vh - 305px);
  }
`;
const TryImg = styled.img`
  max-width: 150px;
  /* position: absolute; */
  top: 10%;
  left: 30%;
  z-index: 1;
  // Extra small devices (portrait phones, less than 576px)
  @media (max-width: 575.98px) {
    width: 50px;
    /* left: 20%; */
  }

  // Small devices (landscape phones, 576px and up)
  @media (min-width: 576px) and (max-width: 767.98px) {
    width: 60px;
    /* left: 20%; */
  }

  // Medium devices (tablets, 768px and up)
  @media (min-width: 768px) and (max-width: 991.98px) {
    width: 70px;
    /* left: 10%; */
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    width: 80px;
    /* left: 20%; */
    /* width: 85px;
    bottom: 105px;
    left: -12px; */
  }
  @media (min-width: 1200px) and (max-width: 1365px) {
    width: 100px;
    /* left: 26%; */
    /* width: 110px;
    left: -10px; */
  }
  @media (min-width: 1366px) and (max-width: 1447.8px) {
    width: 100px;
    /* left: 30%; */
    /* width: 110px;
    bottom: 190px;
    left: -15px; */
  }
  @media (min-width: 1448px) {
    /* left: 20%; */
    width: 130px;
  }
`;
const RightWrapper = styled.div`
  width: 64%;
  height: 100%;
  background: #2a2a2a;
  padding: 30px 35px 20px;
  p {
    color: #9597a6;
    font-family: 'Roboto';
    font-size: 14px;
  }
  // display: flex;
  // flex-direction: column;
  // align-items: center;

  @media (min-width: 992px) and (max-width: 1199px) {
  }
  @media (min-width: 1200px) and (max-width: 1365px) {
  }
  @media (min-width: 1366px) and (max-width: 1448px) {
  }
`;
const BorderWrapper = styled.div`
  height: 100%;
  border: 1px solid #585858;
  border-radius: 20px;
  /* padding: 20px 60px 10px; */
  /* display: flex;
  flex-direction: column;
  align-items: center;
  align-items: center; */
  position: relative;
  /* overflow: hidden; */
`;

const TopWrapper = styled.div`
  /* background: #2a2a2a; */
  padding: 0px 10px;
  position: absolute;
  margin: 0 auto;
  width: 100%;
  top: -18px;
  /* position: absolute;
  top: -12px;
  left: 230px; */
  h3 {
    font-weight: 500;
    color: #ffffff;
    margin: 0px !important;
    font-family: 'Roboto';
    text-align: center;
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    h3 {
      font-size: 16px;
    }
  }
  @media (min-width: 1200px) and (max-width: 1365px) {
    h3 {
      font-size: 17px;
    }
  }
  @media (min-width: 1366px) and (max-width: 1448px) {
    h3 {
      font-size: 18px;
    }
  }
`;
const ToplabelWrapper = styled.div`
  position: relative;
  margin: 0 0 0 0;
  background: none;
  display: flex;
  justify-content: center;
  h3 {
    display: inline-grid;
    background: #2a2a2a !important;
    font-weight: 500;
    color: #ffffff;
    padding-top: 10px;
    margin: 0px !important;
    font-family: 'Roboto';
    font-family: 'Arimo' !important;
    font-size: 22px;
    text-align: center;
    padding: 0 15px;
  }
  .insurance-span {
    font-size: 13px !important;
    letter-spacing: 0.2px;
    font-family: 'Arimo' !important;
    line-height: 25px;
  }
  @media (min-width: 100px) and (max-width: 319px) {
    .insurance-span {
      font-size: 10px;
    }
  }
  @media (min-width: 320px) and (max-width: 575px) {
    .insurance-span {
      font-size: 9px;
    }
  }
  @media (min-width: 576px) and (max-width: 767px) {
    .insurance-span {
      font-size: 10px;
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .insurance-span {
      font-size: 11px;
    }
  }
  @media (min-width: 100px) and (max-width: 319px) {
    h3 {
      font-size: 13px;
    }
  }
  @media (min-width: 320px) and (max-width: 575px) {
    h3 {
      font-size: 13px;
    }
  }
  @media (min-width: 576px) and (max-width: 767px) {
    h3 {
      font-size: 14px;
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    h3 {
      font-size: 18px;
    }
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    h3 {
      font-size: 19px;
    }
  }
  @media (min-width: 1200px) and (max-width: 1365px) {
    padding: 0 60px 0;
    h3 {
      font-size: 20px;
    }
  }
  @media (min-width: 1366px) and (max-width: 1448px) {
    padding: 0 80px 0;
    h3 {
      font-size: 21px;
    }
  }
`;

export default CoachTryItLayout;
